import { lazy, Suspense, useEffect } from "react";
import { getCSRFToken } from "@utils/csrf";
import { useVersionCheck } from "@hooks/useVersionCheck";
import { Spinner } from "@components/Spinner";
import { useClientPanel } from "@hooks/useClientPanel";
import useGoogleTagManagerScript from "@hooks/helpers/useGoogleTagManagerScript";
const ClientRoutes = lazy(() => import("./ClientRoutes"));
const Routes = lazy(() => import("./AppRoutes"));

export function App() {
  useGoogleTagManagerScript();
  useVersionCheck();
  useEffect(() => {
    getCSRFToken();
    const interval = setInterval(() => getCSRFToken(), 300000);
    return () => clearInterval(interval);
  }, []);

  const { isClientPanel } = useClientPanel();

  return (
    <Suspense fallback={<Spinner className="h-screen" />}>
      {isClientPanel ? <ClientRoutes /> : <Routes />}
    </Suspense>
  );
}

export default App;
